module.exports = __webpack_public_path__ + "img/gf.fbc48d82.png";